// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 管理员登录 使用邮箱密码登录管理后台，会验证用户是否具有管理员权限 POST /api/admin/auth/login */
export async function postAdminAuthLogin(
  body: {
    email: string;
    password: string;
  },
  options?: { [key: string]: any }
) {
  return request<{
    success: boolean;
    data: {
      user: { id: string; name: string; email: string; role: string };
      token: string;
      message: string;
    };
  }>("/api/admin/auth/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 退出登录 退出当前管理员登录状态，清除会话信息 POST /api/admin/auth/logout */
export async function postAdminAuthLogout(options?: { [key: string]: any }) {
  return request<{ success: boolean; data: { message: string } }>(
    "/api/admin/auth/logout",
    {
      method: "POST",
      ...(options || {}),
    }
  );
}

/** 获取当前管理员信息 获取当前登录管理员的用户信息和会话信息 GET /api/admin/auth/me */
export async function getAdminAuthMe(options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    data: {
      user: {
        id: string;
        name: string;
        email: string;
        image: string;
        role: string;
        createdAt: string;
      };
      session: { id: string; expiresAt: string };
    };
  }>("/api/admin/auth/me", {
    method: "GET",
    ...(options || {}),
  });
}

/** 验证管理员状态 检查当前用户是否是管理员并且已认证 GET /api/admin/auth/status */
export async function getAdminAuthStatus(options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    data: { isAdmin: boolean; isAuthenticated: boolean };
  }>("/api/admin/auth/status", {
    method: "GET",
    ...(options || {}),
  });
}
